
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.14.0
 * Query Engine version: 2b0c12756921c891fec4f68d9444e18c7d5d4a6a
 */
Prisma.prismaVersion = {
  client: "3.14.0",
  engine: "2b0c12756921c891fec4f68d9444e18c7d5d4a6a"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.CategoriesScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  selectable: 'selectable',
  donation_percentage: 'donation_percentage',
  shipping_price: 'shipping_price',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.CompaniesScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  fulfilment_type: 'fulfilment_type',
  created_by: 'created_by',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.DonationsScalarFieldEnum = makeEnum({
  id: 'id',
  fundraiser_id: 'fundraiser_id',
  payment_id: 'payment_id',
  amount: 'amount',
  email: 'email',
  name: 'name',
  referred_by: 'referred_by',
  message: 'message',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Failed_jobsScalarFieldEnum = makeEnum({
  id: 'id',
  uuid: 'uuid',
  connection: 'connection',
  queue: 'queue',
  payload: 'payload',
  exception: 'exception',
  failed_at: 'failed_at'
});

exports.Prisma.FilesScalarFieldEnum = makeEnum({
  id: 'id',
  attachable_type: 'attachable_type',
  attachable_id: 'attachable_id',
  user_id: 'user_id',
  position: 'position',
  type: 'type',
  is_main: 'is_main',
  shopify_image_id: 'shopify_image_id',
  file_name: 'file_name',
  hash_name: 'hash_name',
  extension: 'extension',
  mime: 'mime',
  size: 'size',
  path: 'path',
  url: 'url',
  optimized_url: 'optimized_url',
  thumbnail_url: 'thumbnail_url',
  notes: 'notes',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Fundraiser_categoriesScalarFieldEnum = makeEnum({
  id: 'id',
  fundraiser_id: 'fundraiser_id',
  category_id: 'category_id',
  sort: 'sort',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Fundraiser_prizesScalarFieldEnum = makeEnum({
  id: 'id',
  fundraiser_id: 'fundraiser_id',
  prize_id: 'prize_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Fundraiser_productsScalarFieldEnum = makeEnum({
  id: 'id',
  fundraiser_id: 'fundraiser_id',
  product_id: 'product_id',
  sort: 'sort',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Fundraiser_top_productsScalarFieldEnum = makeEnum({
  id: 'id',
  fundraiser_id: 'fundraiser_id',
  product_id: 'product_id',
  sort: 'sort',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.FundraisersScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  sales_agent_id: 'sales_agent_id',
  team_id: 'team_id',
  goal_amount: 'goal_amount',
  individual_goal_amount: 'individual_goal_amount',
  slug: 'slug',
  name: 'name',
  description: 'description',
  address: 'address',
  city: 'city',
  state: 'state',
  zip: 'zip',
  phone: 'phone',
  email: 'email',
  color_scheme: 'color_scheme',
  color_scheme_2: 'color_scheme_2',
  status: 'status',
  total_donations: 'total_donations',
  commission_percentage: 'commission_percentage',
  youtube_video_id: 'youtube_video_id',
  share_sms: 'share_sms',
  share_email: 'share_email',
  custom_merchandise: 'custom_merchandise',
  custom_commission: 'custom_commission',
  processing_fee: 'processing_fee',
  donation_percentage: 'donation_percentage',
  cash_donation: 'cash_donation',
  individual_pages: 'individual_pages',
  leaderboard: 'leaderboard',
  redirect_url: 'redirect_url',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.InventoriesScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  product_id: 'product_id',
  shopify_variant_id: 'shopify_variant_id',
  quantity: 'quantity',
  variation: 'variation',
  sku: 'sku',
  price: 'price',
  option1: 'option1',
  option2: 'option2',
  option3: 'option3',
  shopify_image_id: 'shopify_image_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Invoice_itemsScalarFieldEnum = makeEnum({
  id: 'id',
  invoice_id: 'invoice_id',
  product_id: 'product_id',
  inventory_id: 'inventory_id',
  description: 'description',
  quantity: 'quantity',
  price: 'price',
  line_total: 'line_total',
  donation_total: 'donation_total',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.InvoicesScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  order_id: 'order_id',
  sub_total: 'sub_total',
  shipping_total: 'shipping_total',
  tax_total: 'tax_total',
  total: 'total',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.MigrationsScalarFieldEnum = makeEnum({
  id: 'id',
  migration: 'migration',
  batch: 'batch'
});

exports.Prisma.Order_itemsScalarFieldEnum = makeEnum({
  id: 'id',
  order_id: 'order_id',
  product_id: 'product_id',
  inventory_id: 'inventory_id',
  description: 'description',
  quantity: 'quantity',
  price: 'price',
  line_total: 'line_total',
  status: 'status',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.OrdersScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  fundraiser_id: 'fundraiser_id',
  sub_total: 'sub_total',
  shipping_total: 'shipping_total',
  total: 'total',
  status: 'status',
  shopify_order_ids: 'shopify_order_ids',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Organization_teamsScalarFieldEnum = makeEnum({
  id: 'id',
  organization_id: 'organization_id',
  team_id: 'team_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.OrganizationsScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  slug: 'slug',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.PaymentsScalarFieldEnum = makeEnum({
  id: 'id',
  fundraiser_id: 'fundraiser_id',
  user_id: 'user_id',
  invoice_id: 'invoice_id',
  sub_total: 'sub_total',
  processing_fee: 'processing_fee',
  total: 'total',
  commission: 'commission',
  charge_id: 'charge_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Personal_access_tokensScalarFieldEnum = makeEnum({
  id: 'id',
  tokenable_type: 'tokenable_type',
  tokenable_id: 'tokenable_id',
  name: 'name',
  token: 'token',
  abilities: 'abilities',
  last_used_at: 'last_used_at',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.PlayersScalarFieldEnum = makeEnum({
  id: 'id',
  uuid: 'uuid',
  team_id: 'team_id',
  user_id: 'user_id',
  email: 'email',
  first_name: 'first_name',
  last_name: 'last_name',
  phone: 'phone',
  goal_amount: 'goal_amount',
  share_email: 'share_email',
  share_sms: 'share_sms',
  created_at: 'created_at',
  updated_at: 'updated_at',
  views_count: 'views_count'
});

exports.Prisma.PrizesScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  amount: 'amount',
  created_at: 'created_at',
  updated_at: 'updated_at',
  description: 'description',
  is_custom: 'is_custom',
  type: 'type',
  app: 'app'
});

exports.Prisma.Product_codesScalarFieldEnum = makeEnum({
  id: 'id',
  product_id: 'product_id',
  code: 'code',
  order_item_id: 'order_item_id',
  status: 'status',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Product_optionsScalarFieldEnum = makeEnum({
  id: 'id',
  product_id: 'product_id',
  name: 'name',
  values: 'values',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.ProductsScalarFieldEnum = makeEnum({
  id: 'id',
  company_id: 'company_id',
  store_id: 'store_id',
  shopify_product_id: 'shopify_product_id',
  type: 'type',
  status: 'status',
  category_id: 'category_id',
  name: 'name',
  description: 'description',
  shop_url: 'shop_url',
  redeem_url: 'redeem_url',
  shipping_price: 'shipping_price',
  donation: 'donation',
  donation_percentage: 'donation_percentage',
  created_by: 'created_by',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.SessionsScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  ip_address: 'ip_address',
  user_agent: 'user_agent',
  payload: 'payload',
  last_activity: 'last_activity'
});

exports.Prisma.StoresScalarFieldEnum = makeEnum({
  id: 'id',
  store: 'store',
  access_token: 'access_token',
  scopes: 'scopes',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Team_usersScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  team_id: 'team_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.TeamsScalarFieldEnum = makeEnum({
  id: 'id',
  slug: 'slug',
  uuid: 'uuid',
  user_id: 'user_id',
  name: 'name',
  color_scheme_2: 'color_scheme_2',
  color_scheme: 'color_scheme',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.UsersScalarFieldEnum = makeEnum({
  id: 'id',
  uuid: 'uuid',
  type: 'type',
  shopify_customer_id: 'shopify_customer_id',
  first_name: 'first_name',
  last_name: 'last_name',
  email: 'email',
  address: 'address',
  city: 'city',
  state: 'state',
  postal_code: 'postal_code',
  phone: 'phone',
  contact_email: 'contact_email',
  email_verified_at: 'email_verified_at',
  password: 'password',
  two_factor_secret: 'two_factor_secret',
  two_factor_recovery_codes: 'two_factor_recovery_codes',
  remember_token: 'remember_token',
  profile_photo_path: 'profile_photo_path',
  notify_donation: 'notify_donation',
  notify_share: 'notify_share',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Websockets_statistics_entriesScalarFieldEnum = makeEnum({
  id: 'id',
  app_id: 'app_id',
  peak_connection_count: 'peak_connection_count',
  websocket_message_count: 'websocket_message_count',
  api_message_count: 'api_message_count',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Ollie_player_mappingScalarFieldEnum = makeEnum({
  id: 'id',
  ollie_player_id: 'ollie_player_id',
  ollie_team_id: 'ollie_team_id',
  ollie_org_id: 'ollie_org_id',
  flex_player_id: 'flex_player_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Ollie_org_fundraiser_mappingScalarFieldEnum = makeEnum({
  id: 'id',
  ollie_org_id: 'ollie_org_id',
  flex_team_id: 'flex_team_id',
  fundraiser_end_date: 'fundraiser_end_date',
  fundraiser_visibility_status: 'fundraiser_visibility_status',
  created_at: 'created_at',
  updated_at: 'updated_at',
  org_fundraiser_image_url: 'org_fundraiser_image_url',
  org_sponsorship_player_percent: 'org_sponsorship_player_percent',
  team_sponsorship_player_percent: 'team_sponsorship_player_percent',
  org_commission_percent: 'org_commission_percent',
  org_fundraiser_goal: 'org_fundraiser_goal',
  funds_go_to_team: 'funds_go_to_team'
});

exports.Prisma.Ollie_team_mappingScalarFieldEnum = makeEnum({
  id: 'id',
  ollie_team_id: 'ollie_team_id',
  ollie_org_id: 'ollie_org_id',
  flex_team_id: 'flex_team_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  fundraiser_end_date: 'fundraiser_end_date',
  fundraiser_visibility_status: 'fundraiser_visibility_status',
  team_sponsorship_player_percent: 'team_sponsorship_player_percent',
  ollie_org_fundraiser_id: 'ollie_org_fundraiser_id',
  funds_go_to_team: 'funds_go_to_team'
});

exports.Prisma.ReferralsScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  phone: 'phone',
  entity_name: 'entity_name',
  referred_by_player_id: 'referred_by_player_id',
  ollie_account_id: 'ollie_account_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Page_viewsScalarFieldEnum = makeEnum({
  id: 'id',
  viewable_type: 'viewable_type',
  viewable_id: 'viewable_id',
  ip_address: 'ip_address',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Oauth_access_tokensScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  client_id: 'client_id',
  name: 'name',
  scopes: 'scopes',
  revoked: 'revoked',
  created_at: 'created_at',
  updated_at: 'updated_at',
  expires_at: 'expires_at'
});

exports.Prisma.Oauth_auth_codesScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  client_id: 'client_id',
  scopes: 'scopes',
  revoked: 'revoked',
  expires_at: 'expires_at'
});

exports.Prisma.Oauth_clientsScalarFieldEnum = makeEnum({
  id: 'id',
  user_id: 'user_id',
  name: 'name',
  secret: 'secret',
  provider: 'provider',
  redirect: 'redirect',
  personal_access_client: 'personal_access_client',
  password_client: 'password_client',
  revoked: 'revoked',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Oauth_personal_access_clientsScalarFieldEnum = makeEnum({
  id: 'id',
  client_id: 'client_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.Oauth_refresh_tokensScalarFieldEnum = makeEnum({
  id: 'id',
  access_token_id: 'access_token_id',
  revoked: 'revoked',
  expires_at: 'expires_at'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});
exports.fundraisers_custom_merchandise = makeEnum({
  yes: 'yes',
  no: 'no'
});

exports.Prisma.ModelName = makeEnum({
  categories: 'categories',
  companies: 'companies',
  donations: 'donations',
  failed_jobs: 'failed_jobs',
  files: 'files',
  fundraiser_categories: 'fundraiser_categories',
  fundraiser_prizes: 'fundraiser_prizes',
  fundraiser_products: 'fundraiser_products',
  fundraiser_top_products: 'fundraiser_top_products',
  fundraisers: 'fundraisers',
  inventories: 'inventories',
  invoice_items: 'invoice_items',
  invoices: 'invoices',
  migrations: 'migrations',
  order_items: 'order_items',
  orders: 'orders',
  organization_teams: 'organization_teams',
  organizations: 'organizations',
  payments: 'payments',
  personal_access_tokens: 'personal_access_tokens',
  players: 'players',
  prizes: 'prizes',
  product_codes: 'product_codes',
  product_options: 'product_options',
  products: 'products',
  sessions: 'sessions',
  stores: 'stores',
  team_users: 'team_users',
  teams: 'teams',
  users: 'users',
  websockets_statistics_entries: 'websockets_statistics_entries',
  ollie_player_mapping: 'ollie_player_mapping',
  ollie_org_fundraiser_mapping: 'ollie_org_fundraiser_mapping',
  ollie_team_mapping: 'ollie_team_mapping',
  referrals: 'referrals',
  page_views: 'page_views',
  oauth_access_tokens: 'oauth_access_tokens',
  oauth_auth_codes: 'oauth_auth_codes',
  oauth_clients: 'oauth_clients',
  oauth_personal_access_clients: 'oauth_personal_access_clients',
  oauth_refresh_tokens: 'oauth_refresh_tokens'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
